module.exports = __webpack_public_path__ + "static/media/Newsitem-Checkout-environment-to-enjoy-min.e14f9422.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Newsitem-Checkout-environment-to-enjoy-min.jpg
// module id = 174
// module chunks = 0